<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :disabled="disabled"
            :multiple="multiple"
            :autoComplete="autoComplete"
            :dense="dense"
            @change="$emit('change')"
            @clearSelected="$emit('clearSelected')"
            :outlined="outlined"
            :hideDetails="hideDetails"
            :class="classe"
            :classe="classe"
        />
        <sys-register-base-group @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectBaseGroup',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        modelObject: {
        
        },
        dense: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: [Boolean,String],
            default: false
        },
        classe: {

        },
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },

        model(val){
            this.selected = val;
        },
        
    },
    methods: {
        ...mapActions('baseGroup', ['ActionIndexBaseGroupStatus']),        
        
        getItems() {

            this.loading = true;

            this.ActionIndexBaseGroupStatus()
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
        
            if(item){
                
                this.items.push(item);
                
                if(this.multiple){
                    
                    if(!this.selected){
                        this.selected = [];
                    }

                    this.selected.push(item);
                }else{
                    this.selected = item.id;
                }
                
                    this.showForm = false;

                }
        }
    },
    
}
</script>